export const SUPERVISOR_QUEUE_TAG = 'supervisor-queue';
export const STATUS_TEXT_TO_CODE = {
  COMPLETED: 'completed',
  FINALIZED_A2: 'finalized_a2',
  FINALIZED_A1: 'finalized_a1',
  CONFLICTS_PENDING: 'conflicts_pending',
} as const;
